import { Archive, EyeOff, Inbox } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useAuth } from "@/app/auth/context";
import { EmptyState } from "@/components/ui/EmptyState";

/**
 * Nothing to show: says why. A user whose roles give no queue at all sees an explanation and what to ask for,
 * rather than being told the archive is empty.
 */
export function ArchiveEmptyState() {
  const { t } = useTranslation();
  const { me } = useAuth();
  const scope = me?.data_scope ?? "all";
  if (scope === "none") {
    return (
      <EmptyState icon={EyeOff} title={t("archive.noScopeTitle")}>
        {t("archive.noScopeBody")}
      </EmptyState>
    );
  }
  if (scope === "some") {
    return (
      <EmptyState icon={Inbox} title={t("archive.emptyScopeTitle")}>
        {t("archive.emptyScopeBody")}
      </EmptyState>
    );
  }
  return (
    <EmptyState icon={Archive} title={t("archive.emptyTitle")}>
      {t("archive.emptyBody")}
    </EmptyState>
  );
}
